export default __webpack_public_path__ + "static/media/splunk.50507a10.svg";